module.exports = __webpack_public_path__ + "static/media/referral-awoof.2a6a9155.svg";